import React, { useEffect, useState } from 'react';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import { parseEpochToTimeRefresherDateString } from '../../utils/helpers';

const RefreshTimer = ({ lastUpdateTime }) => {
  return (
    <Row alignmentHorizontal="justify" width="100%">
      <Text type="b200">Data last updated: {parseEpochToTimeRefresherDateString(lastUpdateTime)}</Text>
    </Row>
  );
};

export default RefreshTimer;
